export { default } from './Rectangle'
